import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { ArrowLeft, PlugZap } from 'lucide-react'
import { useT } from '../i18n/LanguageContext'
import { useDocumentMeta } from '../hooks/useDocumentMeta'
import EmbedMount from '../components/EmbedMount'
import {
  pluginCommerceDemoConfig,
  isDemoConfigured,
} from '../config/pluginCommerceDemo'

export default function PluginCommerceDemo() {
  const t = useT()
  const demo = t.pluginCommerce.demo
  useDocumentMeta(demo.meta.title, demo.meta.description)

  const configured = isDemoConfigured(pluginCommerceDemoConfig)
  // Rama dopasowuje się do motywu widżetu: ciemny widżet w białej karcie
  // wyglądałby jak wklejka, jasny w ciemnej — odwrotnie.
  const widgetIsDark = pluginCommerceDemoConfig.dataset?.theme === 'dark'

  return (
    <section className="relative pt-40 pb-28 min-h-screen overflow-hidden">
      <div className="absolute inset-0 bg-radial-top" aria-hidden="true" />

      <div className="relative z-10 max-w-4xl mx-auto px-6">
        <motion.header
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mb-12"
        >
          <Link
            to="/plugin-commerce"
            className="inline-flex items-center gap-2 text-sm text-zinc-500 hover:text-white transition-colors mb-8"
          >
            <ArrowLeft size={16} />
            {demo.backToProduct}
          </Link>
          <p className="font-mono text-commerce-400 text-xs tracking-[0.2em] uppercase mb-5">
            {demo.eyebrow}
          </p>
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light text-white tracking-tight leading-[1.05] mb-5">
            {demo.title}
          </h1>
          <p className="text-lg text-zinc-400 leading-relaxed">
            {demo.subtitle}
          </p>
        </motion.header>

        {/* Rama widżetu. Sam widżet renderuje się w jasnym motywie (iframe),
            więc dajemy mu jasną kartę, żeby wyglądał jak osadzenie na stronie. */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15 }}
        >
          {configured ? (
            <div
              className={`rounded-2xl p-4 sm:p-6 shadow-2xl shadow-black/40 border ${
                widgetIsDark
                  ? 'bg-white/[0.02] border-white/[0.1]'
                  : 'bg-white border-white/[0.08]'
              }`}
            >
              <EmbedMount />
            </div>
          ) : (
            <div className="rounded-2xl border border-dashed border-white/[0.14] bg-white/[0.02] px-8 py-16 text-center">
              <div className="w-14 h-14 rounded-xl border border-commerce-500/30 bg-commerce-500/10 flex items-center justify-center mx-auto mb-6">
                <PlugZap size={26} className="text-commerce-400" />
              </div>
              <h2 className="font-display text-xl font-semibold text-white tracking-tight mb-3">
                {demo.configNeeded.title}
              </h2>
              <p className="text-zinc-400 leading-relaxed max-w-xl mx-auto">
                {demo.configNeeded.body}
              </p>
              <p className="mt-6 font-mono text-xs text-zinc-600">
                src/config/pluginCommerceDemo.ts
              </p>
            </div>
          )}
        </motion.div>
      </div>
    </section>
  )
}
